// extracted by mini-css-extract-plugin
export var label = "_ht-2";
export var slideContainer = "_ht-0";
export var slider = "_ht-1";